/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const UndoIcon = /*#__PURE__*/ createSvgIcon(
  'UndoIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M6.587 15.287a.723.723 0 01-.53-.218.723.723 0 01-.22-.532c0-.208.073-.385.22-.53a.723.723 0 01.53-.22h5.25c.695 0 1.285-.243 1.771-.729s.73-1.076.73-1.77c0-.695-.244-1.285-.73-1.771a2.41 2.41 0 00-1.77-.73H6.711l1.396 1.417a.729.729 0 010 1.063.718.718 0 01-.52.229.718.718 0 01-.521-.23L4.358 8.559a.681.681 0 01-.156-.24.777.777 0 010-.562.681.681 0 01.156-.24L7.046 4.83a.729.729 0 011.062 0 .758.758 0 01.24.521.681.681 0 01-.219.52L6.712 7.288h5.125c1.111 0 2.056.39 2.834 1.167.777.778 1.166 1.722 1.166 2.833 0 1.112-.389 2.056-1.166 2.834-.778.778-1.723 1.166-2.834 1.166h-5.25z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default UndoIcon;
